export const FEATURE_FLAG_KEYS = {
  LEADERSHIP_IN_ACTION: 'leadership-in-action'
}

export const QUERY_KEYS = {
  MY_FLAGS: 'feature-flags/me',
  USER_FLAGS: 'feature-flags/user'
}
